import React, { memo, useState, useCallback, useEffect, useRef } from 'react';
import CatalogMobFilterSheet from './CatalogMobFilterSheet';
import CatalogSort from './CatalogSort';
import slidersIcon from '../../img/sprite/sliders-horizontal.svg';

const CatalogMobFilters = memo(() => {
    const [openFilter, setOpenFilter] = useState(false);
    const filterRef = useRef(null);

    const toggleFilter = () => {
        setOpenFilter((prev) => !prev);
    };

    const onBackgroundClick = useCallback((e, ref, close) => {
        if (!ref.current) return;

        if (e.target === ref.current) {
            close(false);
        }
    }, []);

    useEffect(() => {
        if (!openFilter) return undefined;

        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        return () => {
            document.body.style.overflow = previousOverflow;
        };
    }, [openFilter]);

    return (
        <div className="catalog__mob-filters">
            <div className="catalog__mob-filters-top">
                <button
                    type="button"
                    className="catalog__mob-filters-toggler"
                    onClick={toggleFilter}
                >
                    <span className="catalog__mob-filters-toggler-icon">
                        <img src={slidersIcon} alt="" width="17" height="17" />
                    </span>
                    Фильтры
                </button>
                <CatalogSort variant="mobile" />
            </div>

            {openFilter && (
            <div
                className="catalog__mob-wrapper-filter is-active"
                ref={filterRef}
                onClick={(e) => onBackgroundClick(e, filterRef, setOpenFilter)}
            >
                <div className="catalog__mob-inner" onClick={(e) => e.stopPropagation()}>
                    <CatalogMobFilterSheet onClose={() => setOpenFilter(false)} />
                </div>
            </div>
            )}
        </div>
    );
});

export default CatalogMobFilters;
